import { FC } from 'react';
import cn from 'classnames';
import { IGifts } from 'base/interfaces/product';
import Image from '@base/lib/ThemeImage';
import { Button } from 'antd';
import styles from './index.module.less';

export type IProdGiftsDetailProps = IGifts['detail'] & {
    checkedId: string;
    setCheckedId: (id: string) => void;
    onSubmit: () => void;
    showSubmitBtn?: boolean;
};

export const ProdGiftsDetail: FC<IProdGiftsDetailProps> = props => {
    const {
        picture,
        label,
        options,
        btnText,
        checkedId,
        setCheckedId,
        onSubmit,
        showSubmitBtn = true,
    } = props;

    return (
        <div className={styles.detail}>
            <div className={styles.picture}>
                <Image
                    {...picture}
                />
            </div>
            <div className={styles.form}>
                <div className={styles.label}>{label}</div>
                <div className={styles.options}>
                    {options.map(item => {
                        return (
                            <div
                                key={item.variantId}
                                className={cn(
                                    styles.option,
                                    { [styles.checked]: checkedId === item.variantId }
                                )}
                                onClick={() => setCheckedId(item.variantId)}
                            >
                                {item.text}
                            </div>
                        )
                    })}
                </div>
                {showSubmitBtn && (
                    <Button
                        type={'primary'}
                        className={styles.btn}
                        onClick={onSubmit}
                    >
                        {btnText}
                    </Button>
                )}
            </div>
        </div>
    )
};